//
//  UserReactivation.tsx
//
//  isana.net,inc. Proprietary and Confidential
//
//  解除済み(isUsed=false)ユーザーの再連携：確認操作なしで自動的に再有効化する。
//  postTenantUserInfo を呼び、テナント台帳を isUsed=true に戻し＋共通基盤トークンを
//  有効化する（研究番号は既存台帳の値を使うため再入力不要）。画面はスピナーのみ。
//  成功時は完了画面へ遷移、失敗時はエラーを表示する。
//

import { type ReactElement, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Box, CircularProgress, Typography } from "@mui/material";
import { postTenantUserInfo } from "../network/googleHealth/api";

interface Props {
  /** JWT 検証で確定した healthUserId */
  healthUserId: string;
  /** 既存台帳の研究番号（再入力不要のため引き継ぐ） */
  fitinsightUniqueId: string;
  /** 既存台帳の所属グループ */
  belongingGroup: string;
}

const UserReactivation = ({
  healthUserId,
  fitinsightUniqueId,
  belongingGroup,
}: Props): ReactElement => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  // 二重実行防止（React StrictMode の effect 二重呼び出し対策）。再有効化はサーバ側も冪等。
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    postTenantUserInfo(healthUserId, fitinsightUniqueId, belongingGroup)
      .then(() => navigate("/google-health-account-linkage-complete"))
      .catch((error: Error) => setErrorMessage(error.message));
  }, [healthUserId, fitinsightUniqueId, belongingGroup, navigate]);

  if (errorMessage) {
    return (
      <Box sx={{ mt: 2 }}>
        <Alert severity="error">{errorMessage}</Alert>
      </Box>
    );
  }

  return (
    <>
      <Typography sx={{ mb: 2 }}>
        連携を再開しています。しばらくお待ちください。
      </Typography>
      <CircularProgress />
    </>
  );
};

export default UserReactivation;
